import React, { useState, useEffect, useContext } from "react";
import "./style.scss";
import moment from "moment";
import FilterIcon from "../../../assets/FliterIcon.svg";
import { Dropdown } from "react-bootstrap";
import StaffSearchbar from "../CommonComponents/StaffSearchbar";
import StaffUpcomingAppointmentsRow from "./staff-upcoming-appointments-row";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { filters } from "./constants";
import newIcon from "../../../assets/newIcn.png";
import CalendarIcon from "../../../assets/calendar.svg";
import AppointmentDateRangePicker from "../../AppointmentHistory/AppointmentDateRangePicker";
import Filter from "../../../assets/Filter.svg";
import StaffFilterModal from "./staff-filter-component";
import StaffSelectedFilter from "./staff-selected-filter";
import Pagination from "../../common/Pagination/Pagination";
import {
  LOCALSTORAGEKEY,
  removeFromLocal,
} from "../../../Util/Helper/localStorageUtils";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

function isJSON(str) {
  try {
    return JSON.parse(localStorage.getItem(str));
  } catch (e) {
    return localStorage.getItem(str);
  }
}

let dashboardDoctorName = localStorage.getItem("dashboardDoctorName");
let dashboardConsultation = isJSON("dashboardConsultation");
let dashboardStartDate = localStorage.getItem("dashboardStartDate")
  ? moment(localStorage.getItem("dashboardStartDate")).format("YYYY-MM-DD")
  : "";
let dashboardEndDate = localStorage.getItem("dashboardEndDate")
  ? moment(localStorage.getItem("dashboardEndDate")).format("YYYY-MM-DD")
  : "";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

function StaffUpcomingAppointments(props) {
  const staff_context = useContext(DoctorContext);
  const [doctorFilterList, setDoctorFilterList] = useState([
    { name: "All", value: "all" },
  ]);
  const [doctor_selected, setDoctorSelected] = useState([]);
  const [showFilterComponent, setShowFilterComponent] = useState(false);
  const [appointmentData, setAppointmentData] = useState([]);
  const [selectedDoctorFilter, setSelectedDoctorFilter] = useState("all");
  const [loading, setLoading] = useState(false);

  const [activeDropDown, setActiveDropDown] = useState("least_recent_first");
  const [show, setShow] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const defaultSetUp = {
    search_string: "",
    sort_order: "all",
    status_filter: "upcoming",
    consultation_filter: dashboardConsultation
      ? dashboardConsultation.value
      : "all",
    rows_per_page: 10,
    start_date: dashboardStartDate ? dashboardStartDate : "",
    end_date: dashboardEndDate ? dashboardEndDate : "",
    mark_check_in_start_date: "",
    mark_check_in_end_date: "",
    procedure_type_filter: "",
    page_no: 1,
    appointment_status_filter: "all",
    summary_card: true,
    dr_name: dashboardDoctorName ? dashboardDoctorName : "",
  };

  const [status, setStatus] = useState("all");

  const [term, setTerm] = useState(defaultSetUp);
  const [mobileFilterData, setMobileFilterData] = useState(null);
  const [resetMobileFilter, setResetMobileFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(props.pageNo || 1);
  const [mobileFilter, setMobileFilter] = useState(false);
  const [selectedConsultation, setSelectedConsultation] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [inputText, setInputText] = useState("");
  const debouncedSearchTerm = useDebounce(inputText, 500);
  const [selectedDoctor, setSelectedDoctor] = useState();
  let PageSize = 10;

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  useEffect(
    () => {
      if (debouncedSearchTerm && debouncedSearchTerm.length) {
        onFilterSubmit({ search_string: debouncedSearchTerm });
      } else {
        onFilterSubmit({ search_string: "" });
      }
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );
  const openDatePicker = () => {
    setShow(!show);
  };

  const getDates = (start, end) => {
    setStartDate(moment(start).format("DD/MM/YYYY"));
    setEndDate(moment(end).format("DD/MM/YYYY"));
  };

  const handleDate = () => {
    setStartDate("");
    setEndDate("");
    removeFromLocal(LOCALSTORAGEKEY.dashboardStartDate);
    removeFromLocal(LOCALSTORAGEKEY.dashboardEndDate);
    fetchCurrentFilterDates("", "");
  };

  const fetchCurrentFilterDates = (startDate, endDate) => {
    if (startDate === "") {
      delete term["start_date"];
      delete term["end_date"];
      setStartDate("");
      setEndDate("");
    } else {
      term["start_date"] = moment(startDate).format("YYYY-MM-DD");
      term["end_date"] = moment(endDate).format("YYYY-MM-DD");
      term["page_number"] = 1;
    }
    setCurrentPage(1);
    setTerm(term);
    fetchUpcomingAppointmentData(term);
  };

  const onFilterSubmit = (event) => {
    let tempTerm = term;

    if ("search_string" in event) {
      tempTerm["search_string"] = event["search_string"].trim();
    }
    if ("sort_order" in event) {
      tempTerm["sort_order"] = event["sort_order"];
    }
    if ("page_number" in event) {
      tempTerm["page_number"] = event["page_number"];
      setCurrentPage(event["page_number"]);
    }
    if ("status_filter" in event) {
      tempTerm["status_filter"] = event["status_filter"];
    }
    if ("dr_name" in event) {
      tempTerm["dr_name"] = event["dr_name"];
      tempTerm["doctor_ids"] = event["doctor_id"];
    }
    if ("consultation_filter" in event) {
      tempTerm["consultation_filter"] = event["consultation_filter"];
    }

    setTerm(tempTerm);
    fetchUpcomingAppointmentData(term);
  };

  function onFilterSuccess({
    appointmentStatus,
    status,
    prescriptionStatus,
    startDate,
    endDate,
    allFilters,
    resetValues,
    dr_name,
  }) {
    setMobileFilterData(allFilters);
    setResetMobileFilter(resetValues);
    setShowFilterComponent(false);
    setMobileFilter(true);
    setStatus(status);
    setSelectedDoctorFilter(dr_name);
    setStartDate(moment(startDate).format("YYYY-MM-DD"));
    setEndDate(moment(endDate).format("YYYY-MM-DD"));
    if (startDate !== "") {
      term["start_date"] = moment(startDate).format("YYYY-MM-DD");
      term["end_date"] = moment(endDate).format("YYYY-MM-DD");
    } else {
      delete term["start_date"];
      delete term["end_date"];
    }
    if (appointmentStatus !== "") {
      term["appointment_filter"] = appointmentStatus;
    } else {
      term["appointment_filter"] = "all";
    }
    if (status !== "") {
      term["consultation_filter"] = status;
    } else {
      term["consultation_filter"] = "all";
    }
    if (dr_name !== "") {
      term["dr_name"] = dr_name;
    } else {
      term["dr_name"] = "";
    }
    if (prescriptionStatus !== "") {
      term["prescription_filter"] = prescriptionStatus;
    } else {
      term["prescription_filter"] = "all";
    }
    term["page_number"] = 1;
    setCurrentPage(1);
    onFilterSubmit(term);
  }

  useEffect(() => {
    let list = [{ name: "All", value: "all" }, ...staff_context.selectedDoctor];
    setDoctorFilterList(list);
    let arr = [];
    staff_context.selectedDoctor.map((data) => arr.push(data.doctor_id));
    setDoctorSelected(arr);
  }, [staff_context.selectedDoctor]);

  useEffect(() => {
    if (doctor_selected.length > 0) {
      fetchStaffUpcomingAppointments(term);
    }
  }, [doctor_selected]);

  function fetchUpcomingAppointments() {
    afterLoginApiAxios
      .post(
        "/doctor/get-upcoming-appointments",
        { doctor_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data.statusCode === 200 && response.data.data) {
            setAppointmentData(response.data.data);
          } else {
            setAppointmentData([]);
          }
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function fetchStaffUpcomingAppointments(data) {
    let filteredDr = "";
    if (localStorage.getItem("dashboardDoctorName")) {
      let dr = JSON.parse(localStorage.getItem("dashboardDoctorName"));
      filteredDr = [dr?.doctor_id];
    } else {
      filteredDr = doctor_selected;
    }
    setLoading(true);
    if (doctor_selected.length > 0) {
      afterLoginApiAxios
        .post(
          "/staff/my-appointments-rev2",
          {
            ...data,
            dr_name: "",
            doctor_id: filteredDr,
            doctor_ids: filteredDr,
            staff_id: staffId,
            page_no: props?.page_number,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("id_token"),
            },
          }
        )
        .then((response) => {
          if (response.data) {
            if (response.data.statusCode === 200 && response.data.result) {
              setAppointmentData(response.data.result);
              setTotalRecords(response.data?.total_rows);
            } else {
              setAppointmentData([]);
              setTotalRecords(0);
            }
          }
          setLoading(false);
        })
        .catch((err) => C2CConsole.log(err));
    }
  }

  function getStatus(data) {
    setStatus(data?.value);
    setSelectedConsultation(data);
    consultationStatus(data.value);
  }
  const consultationStatus = (event) => {
    if (event === "") {
      term["consultation_filter"] = "all";
      setStatus("all");
      onFilterSubmit(term);
      term["page_number"] = 1;
      setCurrentPage(1);
    } else {
      term["page_number"] = 1;
      setCurrentPage(1);
      onFilterSubmit({ consultation_filter: event });
    }
  };

  function getDoctorStatus() {
    let data = JSON.parse(localStorage.getItem("dashboardDoctorName"));
    setSelectedDoctorFilter(data?.value);
    setSelectedDoctor(data);
    doctorStatus(data);
  }
  const doctorStatus = (event) => {
    if (event === "") {
      term["dr_name"] = "all";
      setSelectedDoctorFilter("all");
      onFilterSubmit(term);
      term["page_number"] = 1;
      setCurrentPage(1);
    } else {
      term["page_number"] = 1;
      setCurrentPage(1);
      onFilterSubmit({ dr_name: event.value, doctor_id: event.doctor_id });
    }
  };

  const fetchUpcomingAppointmentData = async (props) => {
    let filteredDr = "";
    if (localStorage.getItem("dashboardDoctorName")) {
      let dr = JSON.parse(localStorage.getItem("dashboardDoctorName"));
      filteredDr = [dr?.doctor_id];
    } else {
      filteredDr = doctor_selected;
    }

    if (doctor_selected?.length > 0 || props.doctor_ids) {
      setLoading(true);
      const response = await afterLoginApiAxios.post(
        "/staff/my-appointments-rev2",
        {
          ...props,
          doctor_ids: filteredDr,
          doctor_id: filteredDr,
          staff_id: staffId,
          rows_per_page: 10,
          page_no: props?.page_number,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      );

      if (response) {
        if (response.status === 200) {
          if (response.data.statusCode === 200) {
            setAppointmentData(response.data.result);
            if (response.data.upcoming_appointments_count > 0) {
              setAppointmentData(response.data.result);
              setTotalRecords(response.data?.total_rows);
            }
            setAppointmentData(response.data.result);
            setTotalRecords(response.data?.total_rows);
          } else {
            setAppointmentData([]);
            setTotalRecords(0);
          }
          setLoading(false);
        } else {
          setAppointmentData([]);
          setTotalRecords(0);
          setLoading(false);
        }
      }
    }
  };

  const resetClick = (event) => {
    setMobileFilterData(null);
    setStartDate("");
    setEndDate("");
    setStatus("all");
    setSelectedDoctorFilter("all");

    if (term["start_date"]) {
      delete term["start_date"];
      delete term["end_date"];
    }
    if ("search_string" in event) {
      term["search_string"] = "";
    }
    delete term["prescription_filter"];
    if ("status_filter" in term) {
      term["status_filter"] = "upcoming";
    }
    if ("dr_name" in term) {
      term["dr_name"] = "all";
    }
    if ("consultation_filter" in term) {
      term["consultation_filter"] = "all";
    }
    setInputText("");
    setTerm(event);
    term["page_number"] = 1;
    setCurrentPage(1);
    fetchUpcomingAppointmentData(term);
  };

  const resetFilter = () => {
    setStatus({ value: "all", label: "All" });
    setStartDate("");
    setEndDate("");
    setSelectedConsultation("");
    setSelectedDoctorFilter({ value: "all", label: "All" });
    setSelectedDoctor("");
    removeFromLocal(LOCALSTORAGEKEY.dashboardStartDate);
    removeFromLocal(LOCALSTORAGEKEY.dashboardEndDate);
    removeFromLocal(LOCALSTORAGEKEY.dashboardConsultation);
    removeFromLocal(LOCALSTORAGEKEY.dashboardDoctorName);

    resetClick(defaultSetUp);
  };

  const handleConsultation = () => {
    setStatus({ label: "All", value: "all" });
    setSelectedConsultation("");
    removeFromLocal(LOCALSTORAGEKEY.dashboardConsultation);
    consultationStatus("");
  };

  const handleDoctor = () => {
    setSelectedDoctorFilter({ label: "All", value: "all" });
    setSelectedDoctor("");
    removeFromLocal(LOCALSTORAGEKEY.dashboardDoctorName);
    doctorStatus("");
  };

  const onSubmit = (event) => {
    term["page_number"] = 1;
    setCurrentPage(1);
    setInputText(event["search_string"]);
  };

  const clearData = () => {
    setInputText("");
    term["page_number"] = 1;
    setCurrentPage(1);
    onFilterSubmit({ search_string: "" });
  };

  const refreshAppointmentsMethod = () => {
    term["search_string"] = "";
    term["sort_order"] = "least_recent_first";
    term["appointment_filter"] = "all";
    term["status_filter"] = "upcoming";
    term["consultation_filter"] = "all";
    term["page_number"] = 1;
    fetchUpcomingAppointmentData(term);
    setActiveDropDown("least_recent_first");
  };

  return (
    <>
      <div className="upcoming-appointment">
        <div className="row">
          <div className="col-sm-5 col-lg-5 col-8">
            <h2 className="mb-3">Upcoming Appointments</h2>
          </div>
          <div className="col-sm-4 col-lg-7 col-4 d-flex">
            <div className="d-sm-none  d-lg-block d-none w-100">
              <StaffSearchbar
                inputText={inputText}
                onChange={(e) => onSubmit({ search_string: e.target.value })}
                clearData={clearData}
                placeholder={"Search by patient name or mobile number"}
              />
            </div>
            <div className="mr-2">
              <Dropdown>
                <Dropdown.Toggle
                  style={{
                    background: "transparent",
                    border: "none",
                    margin: "0px",
                    fontSize: "19px",
                    color: "#fff",
                    borderColor: "#D6DAE5",
                    backgroundColor: "#fff",
                  }}
                >
                  <img src={FilterIcon} style={{ width: "40px" }} />
                </Dropdown.Toggle>

                <Dropdown.Menu className="m-0">
                  <Dropdown.Item
                    style={{
                      fontSize: "13px",
                      padding: "10px 15px",
                      borderBottom: "1px solid #0000001A",
                    }}
                    onClick={() => {
                      setActiveDropDown("least_recent_first");
                      onFilterSubmit({
                        sort_order: "least_recent_first",
                        page_number: 1,
                      });
                    }}
                  >
                    <i
                      className={`fa fa-check mr-3 check-icon-filter ${
                        activeDropDown === "least_recent_first"
                          ? "activeTab"
                          : ""
                      }`}
                    ></i>
                    Least Recent First
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      setActiveDropDown("most_recent_first");
                      onFilterSubmit({
                        sort_order: "most_recent_first",
                        page_number: 1,
                      });
                    }}
                    style={{
                      fontSize: "13px",
                      padding: "10px 15px",
                      borderBottom: "1px solid #0000001A",
                    }}
                  >
                    <i
                      className={`fa fa-check mr-3 check-icon-filter ${
                        activeDropDown === "most_recent_first"
                          ? "activeTab"
                          : ""
                      }`}
                      aria-hidden="true"
                    ></i>
                    Most Recent First
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      setActiveDropDown("patient_name_az");
                      onFilterSubmit({
                        sort_order: "patient_name_az",
                        page_number: 1,
                      });
                    }}
                    style={{
                      fontSize: "13px",
                      padding: "10px 15px",
                      borderBottom: "1px solid #0000001A",
                    }}
                  >
                    <i
                      className={`fa fa-check mr-3 check-icon-filter ${
                        activeDropDown === "patient_name_az" ? "activeTab" : ""
                      }`}
                    ></i>
                    Patient Name (A-Z)
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      setActiveDropDown("patient_name_za");
                      onFilterSubmit({
                        sort_order: "patient_name_za",
                        page_number: 1,
                      });
                    }}
                    style={{
                      fontSize: "13px",
                      padding: "10px 15px",
                    }}
                  >
                    <i
                      className={`fa fa-check mr-3 check-icon-filter ${
                        activeDropDown === "patient_name_za" ? "activeTab" : ""
                      }`}
                    ></i>
                    Patient Name (Z-A)
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="mr-2  d-sm-block d-lg-none">
              <Dropdown
                className="filter-border"
                onClick={() => setShowFilterComponent(true)}
              >
                <Dropdown.Toggle
                  className={"appointment-filter"}
                  style={{
                    background: "transparent",
                    border: "none",
                    margin: "0px",
                    fontSize: "19px",
                    color: "#fff",
                    borderColor: "#D6DAE5",
                    backgroundColor: "#fff",
                  }}
                >
                  <img src={Filter} style={{ width: "30px" }} />
                </Dropdown.Toggle>
              </Dropdown>
            </div>
          </div>
          <div className="d-sm-block d-lg-none d-block w-100 my-3">
            <StaffSearchbar
              inputText={inputText}
              onChange={(e) => onSubmit({ search_string: e.target.value })}
              clearData={clearData}
            />
          </div>
        </div>
        <>
          <div className="row header mx-2 mt-3 mb-2 d-none d-sm-none d-md-flex">
            <div className="col-md-2">Patient Details</div>
            <div className="col-md-3 d-flex">
              {" "}
              <p className="appointment-table-status-col">Doctor Name</p>
              <Dropdown size="sm">
                <Dropdown.Toggle
                  id="dropdownMenu2"
                  className="appointment-dropdown-toggle"
                >
                  <img className="appointment-calendar-icon" src={newIcon} />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="appointment-table-dropdown-menu"
                  style={{ overflowY: "scroll" }}
                >
                  {doctorFilterList.map((item, index) => (
                    <Dropdown.Item
                      onClick={() => {
                        localStorage.setItem(
                          "dashboardDoctorName",
                          JSON.stringify(item)
                        );
                        getDoctorStatus();
                      }}
                      className="appointment-dropdown-item d-flex text-label"
                      key={index}
                    >
                      <i
                        className={`fa fa-check mr-3 check-icon-filter ${
                          selectedDoctorFilter === item.value ? "activeTab" : ""
                        }`}
                        aria-hidden="true"
                      ></i>
                      {item.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="col-md-3 d-flex">
              {" "}
              <p className="appointment-table-status-col">Consultation</p>
              <Dropdown size="sm">
                <Dropdown.Toggle
                  id="dropdownMenu2"
                  className="appointment-dropdown-toggle"
                >
                  <img className="appointment-calendar-icon" src={newIcon} />
                </Dropdown.Toggle>
                <Dropdown.Menu className="appointment-table-dropdown-menu">
                  {filters?.status?.map((item, index) => (
                    <Dropdown.Item
                      onClick={() => {
                        localStorage.setItem(
                          "dashboardConsultation",
                          JSON.stringify(item)
                        );
                        getStatus(item);
                      }}
                      className="appointment-dropdown-item d-flex text-label"
                      key={index}
                    >
                      <i
                        className={`fa fa-check mr-3 check-icon-filter ${
                          status === item.value ? "activeTab" : ""
                        }`}
                        aria-hidden="true"
                      ></i>
                      {item.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {/* <div className="col-md-3">Mobile Number</div> */}
            <div className="col-md-2 d-flex">
              Date & Time
              <img
                className="appointment-calendar-icon"
                src={CalendarIcon}
                onClick={openDatePicker}
                alt="cal"
              />
            </div>
            <div className="col-md-2 text-right pr-4">Action</div>
          </div>
          <StaffSelectedFilter
            start={startDate}
            selectedConsultation={selectedConsultation}
            // selectedAppointmentStatus={selectedAppointmentStatus}
            selectedAppointmentStatus={selectedDoctor}
            end={endDate}
            handleDate={handleDate}
            status={status}
            handleConsultation={handleConsultation}
            resetFilter={resetFilter}
            // appointmentStatus={appointmentStatus}
            handleAppointmentStatus={handleDoctor}
            term={term}
            mobileFilter={mobileFilter}
            mobileFilterData={mobileFilterData}
            // prescriptionFilter={prescriptionFilter}
            resetMobileFilter={resetMobileFilter}
          />
          {loading ? (
            // <Loader />
            <div className="text-center">
              <img src={require("../../../assets/C2C Loader.gif")} />
            </div>
          ) : (
            <>
              <>
                {appointmentData && appointmentData.length > 0 ? (
                  appointmentData.map((appointment, index) => (
                    <StaffUpcomingAppointmentsRow
                      appointment={appointment}
                      doctor_id={userId}
                      key={appointment.appointment_id}
                      refreshAppointmentsMethod={refreshAppointmentsMethod}
                      // slugUrl={slugUrl}
                      fetchUpcomingAppointments={fetchUpcomingAppointments}
                      selected_doctor={staff_context.selectedDoctor}
                    />
                  ))
                ) : (
                  <h5 className="no-data">No data found.</h5>
                )}
              </>
              <div className="bg-grey">
                {appointmentData?.length > 0 ? (
                  <div className="container-fluid mb-3 mt-4 bg-grey">
                    <Pagination
                      className="d-flex justify-content-end"
                      currentPage={currentPage}
                      totalCount={totalRecords}
                      pageSize={PageSize}
                      onPageChange={(page) => {
                        setCurrentPage(page);
                        onFilterSubmit({ page_number: page });
                      }}
                    />
                  </div>
                ) : null}
              </div>
            </>
          )}
        </>

        {show && (
          <div className="staff-dashboard-date-picker">
            <AppointmentDateRangePicker
              fetchDates={(start, end) => {
                localStorage.setItem("dashboardStartDate", start);
                localStorage.setItem("dashboardEndDate", end);
                fetchCurrentFilterDates(start, end);
                getDates(start, end);
              }}
              isDashboard={true}
              closeDatePicker={openDatePicker}
            />
          </div>
        )}
        {showFilterComponent && (
          <StaffFilterModal
            status={status}
            onFilterSuccess={onFilterSuccess}
            selectedDoctorFilter={selectedDoctorFilter}
            show={showFilterComponent}
            handleClose={() => setShowFilterComponent(false)}
            start={startDate}
            end={endDate}
            mobileFilterData={mobileFilterData}
            onResetAllCall={() => {
              setShowFilterComponent(false);
              resetClick(defaultSetUp);
            }}
            doctorFilterList={doctorFilterList}
          />
        )}
      </div>
      {/* } */}
    </>
  );
}

export default StaffUpcomingAppointments;
